import { PIN_HEIGHT, PIN_WIDTH } from './mapPin';

// Hover tooltip of both maps (2026-10-02): a white card floating above a pin
// or a cluster, in the style of the selection card, replacing the dark popup.
// Hover-only, so it never catches the pointer (see the SCSS); the key keeps a
// mousemove across the same marker from rebuilding the popup. A layer's
// mouseleave only hides its own kind (`hide('pin:')`): when the pointer jumps
// straight from a pin onto a cluster, maplibre fires the cluster's mousemove
// before the pin's mouseleave, which would wipe the tooltip just shown.
const CLASS_NAME = 'listing-map-tooltip';
const PIN_GAP = 6;

// The pin's tip sits on the coordinate and its body stands above it, so a
// tooltip anchored below the point (maplibre's "bottom" anchors) has to clear
// the whole pin; the side anchors aim at the middle of the pin body
export const PIN_TOOLTIP_OFFSET = {
  top: [0, PIN_GAP],
  'top-left': [0, PIN_GAP],
  'top-right': [0, PIN_GAP],
  bottom: [0, -(PIN_HEIGHT + PIN_GAP)],
  'bottom-left': [0, -(PIN_HEIGHT + PIN_GAP)],
  'bottom-right': [0, -(PIN_HEIGHT + PIN_GAP)],
  left: [PIN_WIDTH / 2 + PIN_GAP, -PIN_HEIGHT / 2],
  right: [-(PIN_WIDTH / 2 + PIN_GAP), -PIN_HEIGHT / 2]
};
export const CLUSTER_TOOLTIP_OFFSET = 30;

export const createMapTooltip = (getMap) => {
  let popup = null;
  let shownKey = null;

  const hide = (keyPrefix = '') => {
    if (!popup || !shownKey.startsWith(keyPrefix)) return;
    popup.remove();
    popup = null;
    shownKey = null;
  };

  const show = (key, coordinates, content, offset) => {
    if (shownKey === key) return;
    hide();
    popup = new window.maplibregl.Popup({
      closeButton: false,
      closeOnClick: false,
      className: CLASS_NAME,
      offset
    })
      .setLngLat(coordinates)
      .setDOMContent(content)
      .addTo(getMap());
    shownKey = key;
  };

  return { show, hide };
};

const element = (tag, name, text) => {
  const node = document.createElement(tag);
  node.className = `${CLASS_NAME}__${name}`;
  if (text !== undefined) node.textContent = text;
  return node;
};

export const tooltipContent = ({ title, hint }) => {
  const content = element('div', 'content');
  content.append(element('strong', 'title', title), element('span', 'hint', hint));

  return content;
};
